import { Observable } from "rxjs/internal/Observable";
import { catchError, map } from "rxjs/operators";
import { API_URL } from "../../enums/api.enums";
import HttpClient from "../http-client";
import Utils from "../../utils/base-utils";

export default class TranslatorApi {
    static apiURL = API_URL;

    // Lấy danh sách dịch giả - API mới
    static getLstTranslator(): Observable<any> {
        const api = `${TranslatorApi.apiURL.HOST}/${this.apiURL.GET_ALL_TRANSLATOR}`;
        return HttpClient.get(api).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Tạo dịch giả mới - sử dụng format mới với name, description, birthYear
    static addLstTranslator(body: any): Observable<any> {
        const finalBodyrequest = {
            name: body.name,                    // Tên đầy đủ
            description: body.description,      // Mô tả dịch giả (tùy chọn)
            birthYear: body.birthYear          // Năm sinh (tùy chọn)
        };
        // Loại bỏ các trường undefined
        Object.keys(finalBodyrequest).forEach(key => 
            (finalBodyrequest as any)[key] === undefined && delete (finalBodyrequest as any)[key]
        );

        const api = `${TranslatorApi.apiURL.HOST}/${this.apiURL.ADD_TRANSLATOR}`;
        return HttpClient.post(api, finalBodyrequest).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Lấy chi tiết một dịch giả
    static getTranslatorDetail(id: number): Observable<any> {
        const api = `${TranslatorApi.apiURL.HOST}/${this.apiURL.GET_TRANSLATOR_DETAIL}/${id}`;
        return HttpClient.get(api).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Cập nhật dịch giả - sử dụng format mới
    static editTranslator(bodyrequest: any): Observable<any> {
        const finalBodyrequest = {
            name: bodyrequest.name,
            description: bodyrequest.description,
            birthYear: bodyrequest.birthYear
        };
        // Loại bỏ các trường undefined
        Object.keys(finalBodyrequest).forEach(key => 
            (finalBodyrequest as any)[key] === undefined && delete (finalBodyrequest as any)[key]
        );

        const api = `${TranslatorApi.apiURL.HOST}/${this.apiURL.EDIT_TRANSLATOR}/${bodyrequest.id}`;
        return HttpClient.put(api, finalBodyrequest).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Xóa dịch giả
    static deleteTranslator(bodyrequest: any): Observable<any> {
        const api = `${TranslatorApi.apiURL.HOST}/${this.apiURL.DELETE_TRANSLATOR}/${bodyrequest.id}`;
        return HttpClient.delete(api).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }
}
